import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/credit-actions';
import { CreditActions } from '../constants';
import { ICredit } from 'src/types/credit';

export interface CreditState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<ICredit>;
    current: ICredit | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        page: 1,
        inProgress: false,
        meta: {
            updatedAt: null,
        },
    },

    current: null,
    currentFiles: null,
};

export function credits(state: CreditState = initialState, action: Actions | any): CreditState {
    switch (action.type) {
        case requestType(CreditActions.FETCH_CREDITS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(CreditActions.FETCH_CREDITS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(CreditActions.FETCH_CREDITS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(CreditActions.FETCH_CREDIT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(CreditActions.FETCH_CREDIT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(CreditActions.FETCH_CREDIT):
            return { ...state, inProgress: false, error: action.error };

        case successType(CreditActions.DELETE_CREDIT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: ICredit) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(CreditActions.DELETE_CREDIT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
